var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { UserKycStatusSynaps } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { Synaps } from '@synaps-io/verify-sdk';
import { useContext } from 'react';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
export function useKyc() {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser;
    function init() {
        return __awaiter(this, void 0, void 0, function () {
            var userKycInit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, gqlSdk.UserKycInit()];
                    case 1:
                        userKycInit = (_a.sent()).userKycInit;
                        if (!userKycInit)
                            throw new Error('[useAccountKyc][init] Failed to init kyc');
                        return [2 /*return*/, userKycInit.sessionId];
                }
            });
        });
    }
    function startSynapsVerify(sessionId) {
        Synaps.init({
            sessionId: sessionId,
            onFinish: onFinish,
            mode: 'modal',
        });
        Synaps.show();
    }
    function onFinish() {
        setServerLoading(true);
        setTimeout(reconnectUser, 10000);
        setServerLoading(false);
    }
    function initOrContinue() {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!user)
                            return [2 /*return*/];
                        if (!user.kyc) return [3 /*break*/, 1];
                        _a = user.kyc.sessionId;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, init()];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        sessionId = _a;
                        startSynapsVerify(sessionId);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getDisplayedStatus(status) {
        switch (status) {
            case UserKycStatusSynaps.APPROVED: {
                return t('synaps-status.approved');
            }
            case UserKycStatusSynaps.PENDING_VERIFICATION: {
                return t('synaps-status.pending-verficiation');
            }
            case UserKycStatusSynaps.REJECTED: {
                return t('synaps-status.rejected');
            }
            case UserKycStatusSynaps.RESUBMISSION_REQUIRED: {
                return t('synaps-status.resubmission-required');
            }
            case UserKycStatusSynaps.SUBMISSION_REQUIRED: {
                return t('synaps-status.submission-required');
            }
            default:
                return t('common.unknown');
        }
    }
    return { initOrContinue: initOrContinue, getDisplayedStatus: getDisplayedStatus };
}
